import { render, staticRenderFns } from "./routeBtn.vue?vue&type=template&id=87d273c6&scoped=true"
import script from "./routeBtn.vue?vue&type=script&lang=js"
export * from "./routeBtn.vue?vue&type=script&lang=js"
import style0 from "./routeBtn.vue?vue&type=style&index=0&id=87d273c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d273c6",
  null
  
)

export default component.exports